import { Img } from 'react-image';
import { Avatar, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import { UIUser } from 'types';
interface Props {
	companyDetail?: any;
	isFooter: boolean;
	userDetail: UIUser;
	closeDrawer: () => void;
	setIsPositionDrawerOpen: (val: boolean) => void;
}

const LeadNewCompanyDrawerHeaderFooter = ({ companyDetail, isFooter }: Props) => {
	const [avatarImg, setAvatarImg] = useState<string>('');

	const showCompanyAvatar = !isFooter;
	const generateAvatar = useCallback(async () => {
		const res = await generateCompanyLogoAvatarSrc(
			companyDetail?.leadGen?.logo || '',
			companyDetail?.leadGen?.companyUrl || '',
		);
		setAvatarImg(res);
	}, [companyDetail?.leadGen?.companyUrl]);

	useEffect(() => {
		generateAvatar();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [companyDetail?.leadGen?.companyUrl]);

	return (
		<>
			<div className="flex justify-center text-[#28293D] dark:text-white px-4 py-[10px]">
				<div className="flex w-full justify-between">
					{showCompanyAvatar ? (
						<div className="flex gap-4">
							<div>
								<Avatar
									className="drawer-avatar-container"
									size={'md'}
									alt="companyLogo"
									img={avatarImg}
									rounded={true}
									bordered
								/>
							</div>
							<div className="flex gap-2 items-center">
								<div>
									<div
										onClick={() =>
											companyDetail?.leadGen?.companyUrl ? window.open(`${companyDetail?.leadGen?.companyUrl}`, '_blank') : {}
										}
										className={`flex  items-center gap-2 text-xl font-bold text-[#6698FA]  ${companyDetail?.leadGen?.companyUrl ? 'cursor-pointer ' : ''
											} dark:text-inherit`}
									>
										<span className="hover:underline">
											{companyDetail?.leadGen?.sourceCompanyName?.length > 20 ? (
												<Tooltip content={companyDetail?.leadGen?.sourceCompanyName} placement="top">
													{companyDetail?.leadGen?.sourceCompanyName?.length > 20
														? `${companyDetail?.leadGen?.sourceCompanyName?.substring(0, 19)} ...`
														: `${companyDetail?.leadGen?.sourceCompanyName}`}
												</Tooltip>
											) : (
												<>
													{companyDetail?.leadGen?.sourceCompanyName?.length > 20
														? `${companyDetail?.leadGen?.sourceCompanyName?.substring(0, 19)} ...`
														: `${companyDetail?.leadGen?.sourceCompanyName}`}
												</>
											)}
										</span>
										{companyDetail?.leadGen?.companyUrl ? (
											<span>
												<Img
													loading="lazy"
													className=""
													src="/assets/externalLinkIcon.svg"
													alt="externalLinkIcon"
													width="16"
													height="16"
												/>
											</span>
										) : null}
									</div>
								</div>
							</div>
						</div>
					) : null}
				</div>
			</div>
		</>
	);
};

export default LeadNewCompanyDrawerHeaderFooter;
